import { ref, reactive, computed, toRefs, watch } from 'vue'
import router from '../router/route'
import { SHOW_PRICE, NOTIF_PIUTANG } from '../constant/constantApp'

/**
 * STATE (singleton)
 */
const requestCount = ref(0)

const loading = computed(() => requestCount.value > 0)
const routingActive = computed(() => router )
const collapseMenu = ref(false)
const isMobile = ref(false)
const theme = ref("theme-primary")

const state = reactive({
    title:"",
    searching: "",
    showPrice: loadShowPrice(),
    showNotifPiutang: loadNotifPiutang()
})

const alert = reactive({
    visible: false,
    title: "",
    message: "",
    style: "success"
})

function setTitle(title) {
    state.title = title
}

function setShowPrice(status) {
    state.showPrice = status
}

function loadShowPrice() {
    const saved = localStorage.getItem(SHOW_PRICE)
    if (saved === null) return true
    return saved === 'true'
}

function setNotifPiutang(status) {
    state.showNotifPiutang = status
}

function loadNotifPiutang() {
    const saved = localStorage.getItem(NOTIF_PIUTANG)
    if (saved === null) return true
    return saved === 'true'
}

/**
 * LOADING CONTROL (IMPORTANT)
 */
function startLoading() {
    requestCount.value++
}

function stopLoading() {
    if (requestCount.value > 0) {
        requestCount.value--
    }
}

function resetLoading() {
    requestCount.value = 0
}

/**
 * ACTIONS
 */
function toggleSidebar() {
    collapseMenu.value = !collapseMenu.value
}

function setTheme(value) {
    theme.value = value || "theme-primary"
    document.body.setAttribute('data-theme', theme.value)
}

function detectMobile() {
    isMobile.value = window.matchMedia("(max-width: 768px)").matches
}

function showAlert({ title = "", message = "", style = "success" }) {
    alert.visible = true
    alert.title = title
    alert.message = message
    alert.style = style
}

function hideAlert() {
    alert.visible = false
    alert.title = ""
    alert.message = ""
}

watch(
    () => state.showPrice,
    (val) => {
        localStorage.setItem(SHOW_PRICE, val)
    },
    { immediate: true }
)

watch(
    () => state.showNotifPiutang,
    (val) => {
        localStorage.setItem(NOTIF_PIUTANG, val)
    },
    { immediate: true }
)

/**
 * STORE EXPORT
 */
export function useUiStore() {
    return {
        ...toRefs(state),
        loading,
        collapseMenu,
        isMobile,
        theme,
        alert,
        startLoading,
        stopLoading,
        toggleSidebar,
        setTheme,
        detectMobile,
        showAlert,
        hideAlert,
        requestCount,
        routingActive,
        setTitle,
        setShowPrice,
        setNotifPiutang
    }
}